module.exports = function (app) {
    app.directive('postHeaderProvLinkItem', function ($timeout, $rootScope) {
        return {
            template: require('directives/aem/postHeaderProvLinkItem/postHeaderProvLinkItem.html'),
            scope: {
                sideImagePath: "@",
                heading: "@",
                headingLinkUrl: "@",
                description: "@",
                linkImagePath: "@",
                medicalCoverage: "@",
                pharmacyCoverage: "@",
                dentalCoverage: "@",
                dentalCoverageMedicare: "@",
                drugCoverage: "@",
                visionCoverage: "@",
                telemedicine: "@",
                identifier:"@"
            },
            link: function(scope, elem, iAttrs) {
            },
            controller: ['$scope','sessionData','vendorSSOUtility','finderService','services', '$location', 'displayOrHideItemsWrapper', 'pharmacyServiceWrapper' ,
                function($scope,sessionData, vendorSSOUtility, finderService, services, $location, displayOrHideItemsWrapper, pharmacyServiceWrapper){
                $scope.glbFullMemberInfo;
                $scope.glbPsp;
                $scope.glbCurProd;
                $scope.glbCurMember;
                $scope.glbActivePrds;
                $scope.libStorage = {};
                $scope.portalSelectedPlan    = null;
                $scope.gotPortalSelectedPlan = false;
                /*$scope.medicalCoverage = Boolean($scope.medicalCoverage);
                $scope.pharmacyCoverage= Boolean($scope.pharmacyCoverage);
                $scope.dentalCoverage  = Boolean($scope.dentalCoverage);
                $scope.dentalCoverageMedicare = Boolean($scope.dentalCoverageMedicare);
                $scope.drugCoverage    = Boolean($scope.drugCoverage);
                $scope.visionCoverage  = Boolean($scope.visionCoverage);
                $scope.telemedicine    = Boolean($scope.telemedicine);*/
                //Icons
                $scope.showMedicalIcon        = false;
                $scope.showVisionIcon         = false;
                $scope.showDentalIcon         = false;
                $scope.showPharmacyIcon       = false;
                $scope.showTeleMedicine       = false;
                $scope.showDentalMedicareIcon = false;
                $scope.pharmObjFunction       = false;
                $scope.pharmacyTarget         = false;
                $scope.isVitalsActive = (sessionData.appConfig && sessionData.appConfig.PROVIDER && sessionData.appConfig.PROVIDER.VITALS_LIVE) ? sessionData.appConfig.PROVIDER.VITALS_LIVE.booleanValue : false;
                finderService.getCurrentMember().then(function(fullMemberInfo) {
                    $scope.glbFullMemberInfo = fullMemberInfo;
                    $scope.theDomain         = window.location.origin;
                    $scope.theBrand          = fullMemberInfo.brand.toLowerCase();
                    $scope.setFullMemberInfo(fullMemberInfo);
                    $scope.glbCurMember      = $scope.setLibStorageAndReturnCurMember(fullMemberInfo);
                    $scope.glbActivePrds     = $scope.currentActiveProducts(fullMemberInfo); // sets an object that the next line needs
                    var psp = $scope.glbPsp  = $scope.getPortalSelectedPlan();
                    $scope.currentMedicalProduct = $scope.specificActiveProduct('Medical');
                    $scope.latestCoverage    = $scope.portalSelectedPlanSpecificProductByLatestCoverageEffectiveDate('Medical');
                    $scope.isMedicare        = $scope.hasSeniorProduct();
                    $scope.isNewRx           = false;
                    $scope.showLongTerm      = $scope.showLongTerm();

                    // Medical Icon ==============================================================
                    var isBlueExtra          = $scope.isBlueExtra();
                    $scope.showMedicalIcon   = (!isBlueExtra);

                    // Vision Icon ===============================================================
                    // if they have benefitPlanType = Vision, that's aka Blue Branded
                    var hasBlueBranded = $scope.portalSelectedPlanSpecificProduct('Vision'); //specificActiveProduct('Vision');
                    $scope.isExtraBasicOrPlus = $scope.isExtraBasicOrPlus(fullMemberInfo); // this method includes IBC and IBCAH
                    $scope.showVisionIcon     = (hasBlueBranded || $scope.isExtraBasicOrPlus) ? true : false;

                    // Dental Icon ===============================================================
                    var useDentalFunction           = false;
                    $scope.currentDentalProduct     = $scope.specificActiveProduct('Dental');
                    var hasIntegratedDentalProduct  = ($scope.currentMedicalProduct && $scope.currentMedicalProduct.dentalCoverage == 'true');
                    var hasSomeKindOfDentalCoverage = (hasIntegratedDentalProduct || $scope.currentDentalProduct);
                    if (hasSomeKindOfDentalCoverage || $scope.isExtraBasicOrPlus) {
                        $scope.showDentalIcon = true;
                        var leaving = 'this website';
                        var theyareInABlueEdgeGroup = $scope.isInBlueEdgeGroup($scope.currentMedicalProduct, $scope.currentDentalProduct);
                        useDentalFunction = theyareInABlueEdgeGroup;
                        $scope.hasMedicareDentalMN      = $scope.getPortalSelectedPlan().mnMedicareDentalIndicator;
                        $scope.showDentalMedicareIcon   = $scope.hasMedicareDentalMN;
                    }
                    // Pharmacy Icon ======================================================================
                    $scope.pharmacySso = {};
                    $scope.rxCarveOutVendor = null;
                    $scope.showNewRx   = false;
                    // the next method returns an object with showPharmacyIcon, pharmacyTarget, and usePharmFunction;
                    var pharmObj = $scope.setupFindAPharmacy($scope.currentMedicalProduct, $scope.theBrand);
                    //backdoor url for testing the ExpressScripts SSO service
                    if($location.search()['useESSSO'] == 'true') {
                        pharmObj.usePharmFunction = true;
                    }
                    $scope.pharmacyTarget   = pharmObj.pharmacyTarget;
                    $scope.showPharmacyIcon = pharmObj.showFindAPharmacyMod;
                    if(!$scope.showPharmacyIcon) {
                        // Rx carve-outs do not have drug products or a value returned for pharmacyBenefitProviderIndicator.
                        // So we must check if the member is part of a client that has a Rx carve-out pharmacy vendor.
                        var callDisplayHide = displayOrHideItemsWrapper.displayOrHideItemsCall($scope.glbFullMemberInfo.clientList[0].clientNumber, sessionData.groupNumber, ["rxCarveOutVendor"], $scope.theBrand);

                        callDisplayHide.then(function (data) {
                            $scope.rxCarveOutVendor = null;
                            if (data && data.qualifierInfo && data.qualifierInfo.rxCarveOutVendor && data.qualifierInfo.rxCarveOutVendor.length > 0) {
                                $scope.rxCarveOutVendor = data.qualifierInfo.rxCarveOutVendor;
                                $scope.pharmacyTarget   = null;
                                $scope.showPharmacyIcon = pharmObj.showFindAPharmacyMod = true;
                                pharmObj.usePharmFunction = true;
                            }
                        });
                    }
                    if(pharmObj.usePharmFunction == true){
                        $scope.pharmObjFunction = true;
                    }

                    // Online Doctor(Telemedicine) ======================================================================
                    var hasTeleleMedicine=false;
                    var teleMedicineVendorName = "DEFAULT";
                    if ($scope.latestCoverage && $scope.latestCoverage.telemedicineVendorName != null && $scope.latestCoverage.telemedicineVendorName) {
                        teleMedicineVendorName = $scope.latestCoverage.telemedicineVendorName.replace(/\s+/g, '').replace("&", "_");
                    }
                    if ($scope.theBrand.toLowerCase() === 'mincr') {
                        teleMedicineVendorName = ((teleMedicineVendorName && teleMedicineVendorName.toUpperCase() === 'YES') ? teleMedicineVendorName = "OnlineCareAnywhere" : "DEFAULT");
                    }
                    var pennStatePortalClients = "069151,223885,240156";
                    var cnBasedContent         = (pennStatePortalClients.indexOf(sessionData.memberInfo.clientList[0].clientNumber) < 0) ? "": "_PSHOD";
                    //generate Telemedicine vendor key.
                    var teleMedicineKey       = "MBR_TELEMEDICINE_PROVIDER_" + teleMedicineVendorName.toUpperCase() + cnBasedContent;
                    var teleMedicineVendorKey = {
                        "SUPRESS_ONLINECARE_GROUPS" : "SUPRESS_ONLINECARE_GROUPS"
                    };
                    teleMedicineVendorKey[teleMedicineKey] = teleMedicineKey;
                    services.rbsmbl.contentInfo().getContent(teleMedicineVendorKey).then(function(content) {
                        if (content && content.data && content.data.payload && content.data.payload.contentResponse) {
                            if (content.data.payload.contentResponse.length > 0) {
                                var arrGrps       = content.data.payload.contentResponse[0].value.replace(/\s/g, '').split(",");
                                hasTeleleMedicine = (arrGrps.indexOf($scope.getPortalSelectedPlan().groupNumber) == -1);
                                $scope.showTeleMedicine    = hasTeleleMedicine;
                                if($scope.showTeleMedicine == true && $scope.telemedicine == "true"){
                                    document.getElementById($scope.identifier).parentNode.style.display = "";
                                }
                                $scope.teleMedicineContent = JSON.parse(content.data.payload.contentResponse[1].value);
                            }
                        }
                    });
                    var subItems = document.getElementsByClassName("postHeaderProvLinkItem");
                    var width = document.getElementsByClassName("postHeaderProvLinkItem")[0].parentNode.parentNode.style.width;
                    if(width == ""){
                        document.getElementsByClassName("postHeaderProvLinkItem")[0].parentNode.parentNode.style.width = "100%";
                    }
                    if( ($scope.showMedicalIcon == false && $scope.medicalCoverage == "true")||
                        ($scope.showVisionIcon  == false && $scope.visionCoverage == "true") ||
                        (($scope.showDentalIcon  == false || $scope.showDentalMedicareIcon) && $scope.dentalCoverage == "true") ||
                        ($scope.showPharmacyIcon == false && $scope.pharmacyCoverage == "true") ||
                        ($scope.showTeleMedicine == false && $scope.telemedicine == "true") ||
                        ($scope.showDentalMedicareIcon == false && $scope.dentalCoverageMedicare == "true")){

                        document.getElementById($scope.identifier).parentNode.style.display = "none";
                    }
                    if($scope.showMedicalIcon == true && $scope.medicalCoverage == "true"){
                        $scope.target = $scope.isVitalsActive ? '_blank' : '_self';
                    }
                    else{
                        $scope.target = "_blank";
                    }
                }, function(errObj) {console.log('errObj', errObj)});

                $scope.setupFindAPharmacy = function(currentMedicalProduct, theBrand) {
                    var returnObj      = {};
                    var regionIsMnBcbs = (theBrand == 'mincr');
                    var selectedPlanDrugProduct    = $scope.portalSelectedPlanSpecificProductByLatestCoverageEffectiveDate('Drug');
                    var selectedPlanMedicalProduct = $scope.portalSelectedPlanSpecificProductByLatestCoverageEffectiveDate('Medical');
                    var hasDrugCoverageProperty    = (selectedPlanMedicalProduct &&  selectedPlanMedicalProduct.drugCoverage && selectedPlanMedicalProduct.drugCoverage == 'true') ? true : false
                    var hasIntegratedDrugCov       = (selectedPlanMedicalProduct && selectedPlanMedicalProduct.integratedCoverageIndicator && hasDrugCoverageProperty) ? true : false;
                    var currentDrugCoverage        = (selectedPlanDrugProduct && selectedPlanDrugProduct !== null && selectedPlanDrugProduct !== undefined);
                    showFindAPharmacyMod           = (currentDrugCoverage || hasIntegratedDrugCov) ? true : false;
                    var usePharmFunction = false;
                    var pharmacyTarget   = null;
                    if (showFindAPharmacyMod) {
                        usePharmFunction = true;
                        if ($scope.isNewRx) {
                            usePharmFunction = true;
                        }
                    }

                    if ($scope.isNewRx) {
                        pharmacyTarget = null;
                    }

                    returnObj.showFindAPharmacyMod = showFindAPharmacyMod;
                    returnObj.pharmacyTarget       = pharmacyTarget;
                    returnObj.usePharmFunction     = usePharmFunction;
                    return returnObj;
                }

                $scope.isInBlueEdgeGroup = function(medicalProd, dentalProd) {
                    var isInGroup = false;
                    // look for blueEdgeDentalIndv in Dental plan and in Medical plan
                    isInGroup = (medicalProd && (medicalProd.blueEdgeDentalIndv == 'false')) ? true : isInGroup;
                    isInGroup = (dentalProd && (dentalProd.blueEdgeDentalIndv == 'false')) ? true : isInGroup;
                    return isInGroup;
                }

                $scope.isExtraBasicOrPlus = function(theMember) {
                    var itIs = false;
                    var medicalProduct = $scope.portalSelectedPlanSpecificProduct('Medical');
                    var isBlueExtraBasic = false;
                    var isBlueExtraPlus = false;
                    if (medicalProduct) {
                        isBlueExtraBasic = (medicalProduct.isBlueExtraBasic == 'true');
                        isBlueExtraPlus = (medicalProduct.isBlueExtraPlus == 'true');
                    }
                    itIs = (isBlueExtraBasic || isBlueExtraPlus);
                    return itIs;
                }

                    $scope.portalSelectedPlanSpecificProduct = function(theBenefitPlanType) {
                    if ($scope.portalSelectedPlanProducts() && $scope.portalSelectedPlanProducts().length > 0) {
                        var theProduct = null;
                        var prods = $scope.libStorage.portalSelectedPlanProducts;
                        for (i = 0; i < prods.length; i++) {
                            if (prods[i].benefitPlanType == theBenefitPlanType)
                                theProduct = prods[i];
                        }
                    } else {
                        return null;
                    }
                    return theProduct;
                }

                $scope.portalSelectedPlanSpecificProductByLatestCoverageEffectiveDate = function(theBenefitPlanType) {
                    if ($scope.portalSelectedPlanProducts() && $scope.portalSelectedPlanProducts().length > 0) {
                        var theProduct = null;
                        var prods = $scope.libStorage.portalSelectedPlanProducts;
                        var millisBeginDate = null;
                        var latestMillisBeginDate = null;
                        for (i = 0; i < prods.length; i++) {
                            if (prods[i].benefitPlanType == theBenefitPlanType)
                                millisBeginDate = Date.parse(prods[i].coverageConBeginDate);
                            if (millisBeginDate > latestMillisBeginDate) {
                                theProduct = prods[i];
                                latestMillisBeginDate = millisBeginDate;
                            }
                        }
                    } else {
                        return null;
                    }
                    return theProduct;
                }

                $scope.showLongTerm = function () {
                    var appConfigVal = ( sessionData && sessionData.appConfig && sessionData.appConfig.FIND_A_DOCTOR && sessionData.appConfig.FIND_A_DOCTOR.LONG_TERM_RX && sessionData.appConfig.FIND_A_DOCTOR.LONG_TERM_RX.booleanValue ) ? sessionData.appConfig.FIND_A_DOCTOR.LONG_TERM_RX.booleanValue : false;
                    return appConfigVal;
                }

                $scope.hasSeniorProduct = function() {
                    var hasIt = false;
                    if ($scope.portalSelectedPlanProducts()) {
                        var theProductList = $scope.portalSelectedPlanProducts();
                        for (var i = 0; i < theProductList.length; i++) {
                            var theValue = theProductList[i].seniorProductIndicator;
                            hasIt = ((theValue == true) || (theValue == 'true')) ? true : hasIt;
                        }
                    }
                    return hasIt;
                }

                $scope.currentActiveProducts = function() {
                    if ($scope.libStorage.uniqueProducts) {
                        var prods                        = $scope.libStorage.uniqueProducts;
                        $scope.libStorage.activeProducts = [];
                        var milliServerDate              = Date.parse(new Date()); // use serverDate( ) when that is ready in bts
                        for (var i = 0; i < prods.length; i++) {
                            var millisBeginDate   = Date.parse(prods[i].productData.coverageConBeginDate);
                            var millisEndDate     = Date.parse(prods[i].productData.coverageEndDate);
                            var coverageIsCurrent = false;
                            coverageIsCurrent     = ((millisBeginDate < milliServerDate) && (milliServerDate < millisEndDate)); // 12/31/2014
                            if (coverageIsCurrent) {
                                $scope.libStorage.activeProducts.push(prods[i].productData);
                            }
                        }
                        return $scope.libStorage.activeProducts;
                    }
                    else {
                        return null;
                    }
                }

                $scope.specificActiveProduct = function(theBenefitPlanType) {
                    if ($scope.libStorage.activeProducts && $scope.libStorage.activeProducts.length && $scope.libStorage.activeProducts.length > 0) {
                        var theProduct = null;
                        var prods = $scope.libStorage.activeProducts;
                        for (i = 0; i < prods.length; i++) {
                            if (prods[i].benefitPlanType == theBenefitPlanType){
                                theProduct = prods[i];
                            }
                        }
                        return theProduct;
                    } else {
                        return null;
                    }
                }

                $scope.setLibStorageAndReturnCurMember = function(fullMemberInfo) {
                    if ($scope.libStorage.fullMemberInfo == null) {
                        $scope.libStorage.fullMemberInfo = fullMemberInfo;
                    }
                    $scope.libStorage.currentMember  = services.rbsmbl.memberInfo().currentMember($scope.libStorage.fullMemberInfo);//returns subscriber information
                    $scope.libStorage.uniqueProducts = services.rbsmbl.memberInfo().getUniqueProducts($scope.libStorage.fullMemberInfo);//returns unique client+group+product+effectiveDate combinations
                    if ($scope.libStorage.currentMember) {
                        return $scope.libStorage.currentMember;
                    }
                    else {
                        return null;
                    }
                }

                $scope.setFullMemberInfo = function(fmi) {
                    $scope.libStorage.fullMemberInfo = fmi;
                }

                $scope.getPortalSelectedPlan = function() {
                    if (sessionData.memberInfo) {
                        var fm = $scope.libStorage.fullMemberInfo;
                        var psp = services.rbsmbl.memberInfo().getPortalSelectedPlan(fm);//returns product plan whose group matches with user's group loggedIn
                        if (psp) {
                            $scope.gotPortalSelectedPlan = true;
                            $scope.portalSelectedPlan    = psp;
                            return psp;
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                }

                $scope.portalSelectedPlanProducts = function() {
                    var psp;
                    if(!$scope.libStorage.portalSelectedPlanProducts){
                        if(!$scope.gotPortalSelectedPlan && $scope.portalSelectedPlan == null){
                            psp = $scope.getPortalSelectedPlan();
                        }
                        else{
                            psp = $scope.portalSelectedPlan;
                        }
                        if (psp && psp.productList) {
                            var prods = psp.productList;
                            $scope.libStorage.portalSelectedPlanProducts = [];
                            var milliServerDate = Date.parse(new Date()); // use serverDate( ) when that is ready in bts
                            for (var i = 0; i < prods.length; i++) {
                                $scope.libStorage.portalSelectedPlanProducts.push(prods[i]);
                            }
                            return $scope.libStorage.portalSelectedPlanProducts;
                        } else {
                            return null;
                        }
                    }
                    else{
                        return $scope.libStorage.portalSelectedPlanProducts;
                    }
                }

                $scope.isBlueExtra = function(){
                    var blueExtra = false;
                    if ($scope.portalSelectedPlanProducts() && $scope.portalSelectedPlanProducts().length > 0) {
                        var prods = $scope.libStorage.portalSelectedPlanProducts;
                        for (i = 0; i < prods.length; i++) {
                            if (prods[i].isBlueExtraBasic == "true" || prods[i].isBlueExtraPlus == "true") {
                                blueExtra = true;
                            }
                        }
                    }
                    return blueExtra;
                }

                $scope.pharmObjOnClick = function(){
                    if ($scope.isNewRx) {
                        if ($scope.showLongTerm) {
                            var isPreferredRx          = sessionData.medicarePrefValPharmNetInd;
                            var rxTierLinks            = {};
                            rxTierLinks.preferredRxURL = "http://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKMedDPref";
                            rxTierLinks.standardRxURL  = "https://www.express-scripts.com/medco/consumer/mybenefits/medPPOEntry.jsp?memtype=HMKPlPartnr";
                            pharmObj.pharmacyTarget    = isPreferredRx ? rxTierLinks.preferredRxURL : rxTierLinks.standardRxURL;
                            window.open(pharmObj.pharmacyTarget,"searchRXWindow");

                        } else {
                            $scope.showNewRx = !$scope.showNewRx;
                        }
                    } else {
                        // hit the initial service -----------------------------------
                        var prescriptServiceSsoResponse = pharmacyServiceWrapper.doPharmacySsoCall($scope.glbFullMemberInfo, $scope.glbCurMember, $scope.glbPsp, 'locatePharmacy', $scope.rxCarveOutVendor);
                        var ssoWindowName = "_blank";
                        if (prescriptServiceSsoResponse !== null) {
                            prescriptServiceSsoResponse.then(function (vendorSSOStuff) {
                                vendorSSOUtility.genericHandleSSOResponse(vendorSSOStuff, "", ssoWindowName);
                            }, function(error) {
                                vendorSSOUtility.genericHandleSSOFailure(error, ssoWindowName);
                            });
                        } else {
                            vendorSSOUtility.genericHandleSSOFailure("", ssoWindowName);
                        }
                    }
                }
                $scope.navigateToURL = function(headeingLinkURL, target){
                        window.open(headeingLinkURL, target);
                }

                }]
        };
    });
};